import { Log } from 'ng2-logger';
import { all, put, takeEvery } from 'redux-saga/effects';
import { IProjectFetchAllGroupsGetAction } from '../../../src/models/action/project';
import { ProjectService } from '../../api/project-service';
import { Notification } from '../../components/notification/main';
import Translator from '../../core/i18n';
import * as coreActions from '../actions/core';
import * as projectPageActions from '../actions/project';
import * as constants from '../constants/project';
const T = Translator.create();
const _logger = Log.create('project_sagas');
const _projectService = new ProjectService();

//#region "Add Project Activity Saga"
function* setAddProjectActivity(params: any): any {
    let isError = false;
    let errorList: any;
    try {
        const pageData = yield _projectService
            .RequestAddProjectActivityAsync(params)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                }
                return responseData.json();
            })
            .then(response => {
                if (isError) {
                    errorList = response;
                } else {
                    return response;
                }
            });

        if (isError) {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }

        if (!isError) {
            yield put(
                coreActions.newNotification(
                    params.ProjectData.activityId
                        ? T.t('r_update_activity_succesful_notification')
                        : T.t('r_add_activity_succesful_notification'),
                    '',
                    '',
                    'topRight',
                    'success'
                )
            );
            const redirectPageParams: any = {
                submitValues: params.ProjectData,
                activityId: params.ProjectData.activityId ? params.ProjectData.activityId : pageData,
                termWeekId:
                    params.ProjectData.termWeekIds && params.ProjectData.termWeekIds[0] !== '0'
                        ? params.ProjectData.termWeekIds[0]
                        : params.ProjectData.termWeekIds[1]
            };
            params.callback(redirectPageParams);
        }
    } catch (error: any) {
        Notification.setNotification('error', error, 'topRight');
        yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        yield put(projectPageActions.updateProjectSetAction(null));
    }
}

function* setUpdateProjectActivity(params: any) : any {
    let isError = false;
    let errorList: any;

    try {
        const pageData = yield _projectService
            .RequestGetProjectAsync({ ...params, take: 20, skip: 0 })
            .then((response: Response) => {
                return response;
            })
            .then((response: Response) => {
                if (response.status !== 200) {
                    isError = true;
                }
                return response.json();
            })
            .then((responseData: any) => {
                if (isError) {
                    errorList = responseData;
                } else {
                    return responseData;
                }
            })
            .then((data: any | null) => {
                if (!data) {
                    return null;
                } else {
                    return data;
                }
            });

        if(isError) {
            errorList ? 
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            }) : Notification.setNotification('error', T.t('r_api_gen_update_activity_error'), 'topRight');

            return false;
        } else {
            yield put(projectPageActions.updateProjectSetAction(pageData, params.spinnerId, 'set'));
            return true;
        }
    } catch (error: any) {
        Notification.setNotification('error', T.t('r_api_gen_update_activity_error'), 'topRight');
        return false;
    }
}

function* setDeleteProjectActivity(params: any): any {
    try {
        const pageData = yield _projectService
            .RequestDeleteProjectActivityAsync(params)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((data: any | null) => {
                if (data === undefined || data === false) {
                    return null;
                } else {
                    return data;
                }
            });

        yield put(projectPageActions.updateProjectSetAction(null));
    } catch (error: any) {
        _logger.error('in setDeleteProjectActivity', error);
    }
}

function* setDeleteProjectGroup(params: any): any {

        const pageData = yield _projectService
            .RequestDeleteProjectGroup(params)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((data: any | null) => {
                if (data === undefined || data === false) {
                    return null;
                } else {
                    params.callback(params.groupId);
                    return data;
                }
            }).catch(error => _logger.error('in setDeleteProjectGroup', error));
   

}

function* getUserAddModalAllUsers(params: any): any {
    try {
        const pageData = yield _projectService
            .RequestGetUsersAddModal(params)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((data: any | null) => {
                if (!data) {
                    return null;
                } else {
                    return data;
                }
            });
        yield put(projectPageActions.setAddModalUserList(pageData.results, pageData.filters, params.spinnerId, 'set'));
    } catch (error: any) {
        yield put(projectPageActions.setAddModalUserList(null, null, params.spinnerId, 'set'));
        _logger.error('in getUserAddModalAllUsers', error);
    }
    return null;
}
function* addGroup(params: any): any {
    try {
        const pageData = yield _projectService
            .AddGroup(params)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((data: any | null) => {
                if (!data) {
                    return null;
                } else {
                    return data;
                }
            });
        yield put(projectPageActions.setProjectAddGroup(pageData, 'addGroupLoading', 'set'));
    } catch (error: any) {
        _logger.error('in addGroup', error);
    }
    return null;
}

function* autoAddGroup(params: any): any {
    let isError = false;
    let errorList: any;
    try {
        const pageData = yield _projectService
            .AutoAddGroup(params)
            .then((responseData: Response) => {
                return responseData;
            }).then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                }
                return responseData.json();
            }).then((response) => {
                if (isError) {
                    errorList = response;
                } else {
                    return response;
                }
            });
    
            if (isError) {
                errorList ?
                    Object.keys(errorList).forEach((key: any) => {
                        Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                    }) : Notification.setNotification('error', T.t('r_project_page_auto_add_error_message'), 'topRight');
            }
    
            if (!isError) {
                if (pageData && pageData.returnMessage) {
                    Notification.setNotification('info', T.t('r_project_page_' + pageData.returnMessage), 'topRight');
                }
                yield put(projectPageActions.setProjectAutoAddGroup(pageData, 'addGroupLoading', 'set'));
            }
    } catch (error: any) {
        _logger.error('in addGroup', error);
    }
    return null;
}

function* updateGroup(params: any): any {

        const pageData = yield _projectService
            .updateGroup(params)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((data: any | null) => {
                if (!data) {
                    return null;
                } else {
                    params.callback(params.groupId);
                    return data;
                }
            }).catch(error => _logger.error('in updateGroup', error));

    return null;
}

function* fetchAllGroups(params: IProjectFetchAllGroupsGetAction): any {

        const pageData = yield _projectService
            .FetchAllGroups(params)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((data: any | null) => {
                if (!data) {
                    return null;
                } else {
                    return data;
                }
            }).catch(error => _logger.error('in fetchAllGroups', error));

    return null;
}

function* addUsersToGroup(params: any): any {
    let isError = false;
    try {
        const pageData = yield _projectService
            .AddUsersToGroup(params)
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                }
                return responseData;
            })
            .then((data: any | null) => {
                if (!data) {
                    return null;
                } else {
                    return data;
                }
            });

        if (!isError) {
            yield put(coreActions.newNotification(T.t('r_add_users_to_group_successful_notification'), '', '', 'topRight', 'success'));
            params.callback(true);
        }
    } catch (error: any) {
        _logger.error('in addUsersToGroup', error);
    }
    return null;
}

function* fetchUsersOfGroup(params: any): any {
    try {
        const pageData = yield _projectService
            .FetchUsersOfGroup(params)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((data: any | null) => {
                if (!data) {
                    return null;
                } else {
                    return data;
                }
            });
        yield put(projectPageActions.setProjectFetchUsersOfGroup(pageData.results, pageData.filters, undefined, 'set'));
    } catch (error: any) {
        _logger.error('in fetchUsersOfGroup', error);
    }
    return null;
}

export function* watchFetchUsersOfGroup() {
    yield takeEvery(constants.actions.GET_PROJECT_FETCH_USERS_OF_GROUP, fetchUsersOfGroup);
    return null;
}

export function* watchAddGroup() {
    yield takeEvery(constants.actions.GET_PROJECT_ADD_GROUP, addGroup);
    return null;
}

export function* watchAutoAddGroup() {
    yield takeEvery(constants.actions.GET_PROJECT_AUTO_ADD_GROUP, autoAddGroup);
    return null;
}

export function* watchUpdateGroup() {
    yield takeEvery(constants.actions.GET_PROJECT_UPDATE_GROUP, updateGroup);
    return null;
}

export function* watchAddUsersToGroup() {
    yield takeEvery(constants.actions.GET_PROJECT_ADD_USERS_TO_GROUP, addUsersToGroup);
    return null;
}

export function* watchFetchAllGroups() {
    yield takeEvery(constants.actions.GET_PROJECT_FETCH_ALL_GROUPS, fetchAllGroups);
    return null;
}

export function* watchGetUserAddModalAllUsers() {
    yield takeEvery(constants.actions.GET_USER_ADD_MODAL, getUserAddModalAllUsers);
    return null;
}

export function* watchGetAddProjectData() {
    yield takeEvery(constants.actions.ADD_PROJECT_ACTIVITY, setAddProjectActivity);
    return null;
}

export function* watchGetDeleteProjectData() {
    yield takeEvery(constants.actions.DELETE_PROJECT_ACTIVITY, setDeleteProjectActivity);
    return null;
}
export function* watchGetDeleteProjectGroup() {
    yield takeEvery(constants.actions.GET_PROJECT_DELETE_GROUP, setDeleteProjectGroup);
    return null;
}

export function* watchGetUpdateProjectData() {
    yield takeEvery(constants.actions.UPDATE_PROJECT_ACTIVITY, setUpdateProjectActivity);
    return null;
}

//#endregion "Add Project Activity End Saga"

export function* ProjectSagas() {
    yield all([
        watchGetAddProjectData(),
        watchGetDeleteProjectData(),
        watchGetUpdateProjectData(),
        watchAddGroup(),
        watchUpdateGroup(),
        watchFetchAllGroups(),
        watchAddUsersToGroup(),
        watchFetchUsersOfGroup(),
        watchGetDeleteProjectGroup(),
        watchGetUserAddModalAllUsers(),
        watchAutoAddGroup()
    ]);
}
